import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { prod } from '../../../catalog/slice/prod';
import { commaReplace, dotReplace } from '../../../utils';

const re = /^[0-9\b]+$/;

const AmountInput = ({ prod: p, inactive = false }) => {
  const dispatch = useDispatch();

  const { id, unit, unitRate } = p;

  let { multiplier } = p;
  multiplier = Number(multiplier);

  const { amounts } = useSelector((state) => state.prod);
  const { units: activeUnitByProd } = useSelector((state) => state.units);
  const activeUnit = activeUnitByProd[id] ? activeUnitByProd[id] : unit;

  const [q, setQ] = useState(multiplier);
  const [renderedQ, setRenderedQ] = useState(q);
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    const newQ = amounts[id] ? amounts[id] : multiplier;
    setQ(newQ);
  }, [setQ, amounts, id, multiplier]);

  useEffect(() => {
    const { unit, altUnit1, unitRate, unitRate1 } = p;

    if (activeUnit === unit) {
      setRenderedQ(q);
      return;
    }

    if (Number(unitRate) === 0 && Number(unitRate1) === 0) {
      return;
    }

    let rate = unitRate;
    if (activeUnit === altUnit1) {
      rate = unitRate1;
    }
    rate = Number(rate);

    const altAsNum = q * rate;
    if (Number.isInteger(altAsNum)) {
      setRenderedQ(altAsNum);
      return;
    }

    let decimalPlaces = 2;
    const [_, decimals] = (rate + '').split('.');
    if (decimals) {
      decimalPlaces = decimals.length;
    }

    if (decimalPlaces < 2) {
      decimalPlaces = 2;
    }

    let newRenderedQ = altAsNum.toFixed(decimalPlaces);

    if (newRenderedQ.slice(-3) === '.00') {
      newRenderedQ = newRenderedQ.slice(0, newRenderedQ.length - 3);
    }

    setRenderedQ(newRenderedQ);
  }, [q, p, activeUnit, setRenderedQ]);

  const onBlurAmountInput = (evt) => {
    let newVal = evt.target.value;
    newVal = newVal.replace(commaReplace, '.');
    newVal = newVal.replace(dotReplace, '.');

    // skip stored value update if the last char is dot
    if (newVal[newVal.length - 1] === '.') {
      setRenderedQ(newVal);
      return;
    }

    // skip stored value update if new val == 13.2 and current
    // val == 13.20
    if (`${newVal}0` === renderedQ) {
      setRenderedQ(newVal);
      return;
    }

    // skip stored value update if we typed smth like 0000 and
    // set current value of the fld to 0
    if (newVal[0] === '0' && newVal[1] === '0') {
      setRenderedQ('0');
      return;
    }

    let newAmount = Number(newVal);
    if (isNaN(newAmount)) {
      setRenderedQ(q);
      setRefresh(refresh + 1);
      return;
    }

    // skip stored value update if we have somthing like 0,00
    if (newAmount === 0) {
      setRenderedQ(newVal);
      return;
    }

    if (newAmount === 0) {
      setRefresh(refresh + 1);
      return;
    }

    if (activeUnit !== unit) {
      newAmount = newAmount * unitRate;
    }
    dispatch(prod.actions.setAmount({ id, q: newAmount }));
  };

  const onChangeAmountInput = (evt) => {
    const newVal = evt.target.value;
    const ok = newVal === '' || re.test(newVal);

    if (ok) {
      setRenderedQ(newVal);
    }
  };

  const clickMinus = () => dispatch(prod.actions.minus({ id, q: multiplier }));
  const clickPlus = () => dispatch(prod.actions.plus({ id, q: multiplier }));

  return (
    <div className="add-catalog-val-count">
      {!inactive && (
        <>
          <div className="decrement" onClick={clickMinus}>
            <i className="icon minus"></i>
          </div>
          <label>
            <input
              type="text"
              className="catalog-count-value"
              value={renderedQ}
              onBlur={onBlurAmountInput}
              onChange={onChangeAmountInput}
            />
          </label>
          <div className="increment" onClick={clickPlus}>
            <i className="icon plus"></i>
          </div>
        </>
      )}
      {inactive && (
        <>
          <div className="decrement" />
          <label>
            <input
              type="text"
              className="catalog-count-value"
              value={renderedQ}
              disabled
            />
          </label>
          <div className="increment" />
        </>
      )}
    </div>
  );
};

export default AmountInput;
